<script lang="ts" setup>
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';
import type { Breadcrumb } from './Navigation.vue';

// The server shares `breadcrumbs` as null for any route without a definition
// in routes/breadcrumbs.php, and withDefaults only fills in `undefined`. Left
// unguarded, one missing definition throws in render and wedges the whole SPA.
const props = defineProps<{
    breadcrumbs?: Breadcrumb[] | null
}>();

const trail = computed<Breadcrumb[]>(() => props.breadcrumbs ?? []);

</script>

<template>
    <div
        v-if="trail.length > 1"
        class="breadcrumb breadcrumb-3.5 pt-0">
        <template 
            v-for="(breadcrumb, i) in trail"
            :key="`${i}-${breadcrumb.url}`">
            <Link
                :href="breadcrumb.url"
                class="breadcrumb-link"
                :class="{
                    'active': breadcrumb.current,
                    'breadcrumb-icon-home': breadcrumb.data?.icon === 'HomeIcon'
                }">
                <template v-if="!breadcrumb.data?.icon">
                    {{ breadcrumb.title }}
                </template>
            </Link>
        </template>
    </div>
</template>